import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

export interface AnalyticsSection {
  id: string;
  companyId: number;
  lang: Lang;
  title: string;
  order: number;
  dashboards: Dashboard[];
}

export interface Dashboard {
  id: string;
  companyId: number;
  lang: Lang;
  title: string;
  externalId: string;
  sectionId: string;
  order: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
}

export enum Lang {
  En = 'en',
  Es = 'es'
}

export interface AnalyticsCharts {
  data: AnalyticsSection[];
  isLoading: boolean;
  error: any;
}
const initialState: Readonly<AnalyticsCharts> = {
  data: [],
  error: null,
  isLoading: false
};

export default createReducer(initialState, {
  [c.GET_COMPANY_ANALYTICS_CHARTS_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_COMPANY_ANALYTICS_CHARTS_SUCCESS]: (
    state = initialState,
    { payload }
  ) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.GET_COMPANY_ANALYTICS_CHARTS_ERROR]: (
    state = initialState,
    { payload }
  ) => ({
    ...state,
    error: payload,
    isLoading: false
  })
});
